var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98021 5.58656H3.69981C2.30253 5.58656 1.16982 6.67967 1.16982 8.0281V17.0143C1.16982 18.3627 2.30253 19.4559 3.69981 19.4559H18.0365C19.4338 19.4559 20.5665 18.3627 20.5665 17.0143V8.0281C20.5665 6.67967 19.4338 5.58656 18.0365 5.58656H16.7555L15.84 4.24428C15.372 3.5581 14.5779 3.14502 13.7267 3.14502H8.00935C7.15829 3.14502 6.36425 3.55795 5.89624 4.24392L4.98021 5.58656ZM10.8681 16.5904C8.43349 16.5904 6.45981 14.6168 6.45981 12.1821C6.45981 9.74745 8.43349 7.77377 10.8681 7.77377C13.3028 7.77377 15.2765 9.74745 15.2765 12.1821C15.2765 14.6168 13.3028 16.5904 10.8681 16.5904ZM13.954 12.1821C13.954 13.8864 12.5724 15.2679 10.8681 15.2679C9.16389 15.2679 7.78231 13.8864 7.78231 12.1821C7.78231 10.4778 9.16389 9.09627 10.8681 9.09627C12.5724 9.09627 13.954 10.4778 13.954 12.1821Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.bb5da52f.svg";
export { ForwardRef as ReactComponent };